export const AUTH = {
  loginEmail: "login-email-input",
  loginPassword: "login-password-input",
  loginSubmit: "login-submit-button",
  registerName: "register-name-input",
  registerEmail: "register-email-input",
  registerPassword: "register-password-input",
  registerSubmit: "register-submit-button",
  logout: "logout-button",
};

export const NAV = {
  home: "nav-home",
  about: "nav-about",
  services: "nav-services",
  projects: "nav-projects",
  tenders: "nav-tenders",
  rti: "nav-rti",
  downloads: "nav-downloads",
  contact: "nav-contact",
  login: "nav-login",
  dashboard: "nav-dashboard",
  darkToggle: "dark-mode-toggle",
  chatbotFab: "chatbot-fab",
  globalSearch: "global-search-input",
  megaMenu: "mega-menu",
};

export const DASH = {
  ceo: "dashboard-ceo",
  director: "dashboard-director",
  finance: "dashboard-finance",
  hr: "dashboard-hr",
  works: "dashboard-works",
  gis: "dashboard-gis",
  knowledge: "dashboard-knowledge",
  learning: "dashboard-learning",
  itAssets: "dashboard-it-assets",
  inspection: "dashboard-inspection",
  citizen: "dashboard-citizen",
  kpiCard: "kpi-card",
  chart: "dashboard-chart",
};

export const CITIZEN = {
  applyBtn: (s) => `apply-${s}-button`,
  submitApp: "citizen-application-submit",
  trackInput: "track-application-input",
  trackBtn: "track-application-button",
  grievanceSubmit: "grievance-submit-button",
  rtiSubmit: "rti-submit-button",
};
